module.exports = "/images/vendor/flag-icon-css/flags/4x3/nf.svg?99af5a94b011d565f7ab92338a3a8186";